// ./context/instructor/instructorInitialState.js

export default {
    instructorData: null,
    assignedCourses: [],
    pendingLabs: [],
    pendingQuizzes: [],
    pendingExams: [],
    pendingCapstones: [],
    courseStudents: [],
    courseLabs: [],
    courseQuizzes: [],
    courseExams: [],
    courseCapstones: [],
    dashboardStats: null,
    courseAnalytics: null,
    gradingHistory: [],
    generatedRubric: null,
    isRubricGenerating: false,
    rubricError: null,
    isLoading: false,
    error: null
}